import * as tslib_1 from "tslib";
import React from 'react';
import { listen, un } from './FormStateStack';
/**
 * 从表单状态堆栈中监听表单状态变化组件。
 *
 * @private
 */
var FormStateWithFormName = /** @class */ (function (_super) {
    tslib_1.__extends(FormStateWithFormName, _super);
    function FormStateWithFormName(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            formik: undefined,
        };
        _this.onFormStateChange = function (formik) { return _this.setState({ formik: formik }); };
        _this.formName = props.formName;
        return _this;
    }
    FormStateWithFormName.prototype.componentDidMount = function () {
        listen(this.formName, this.onFormStateChange);
    };
    FormStateWithFormName.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.formName !== this.props.formName) {
            un(this.formName, this.onFormStateChange);
            this.formName = nextProps.formName;
            listen(this.formName, this.onFormStateChange);
        }
    };
    FormStateWithFormName.prototype.componentWillUnmount = function () {
        un(this.formName, this.onFormStateChange);
    };
    FormStateWithFormName.prototype.render = function () {
        if (this.state.formik) {
            return this.props.children(this.state.formik);
        }
        return null;
    };
    return FormStateWithFormName;
}(React.Component));
export default FormStateWithFormName;
//# sourceMappingURL=FormStateWithFormName.js.map